import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useLinksSection} from '../useGetProductBulkSection';
import {BreadcrumbsADPLoading} from './BreadcrumbsADPLoading';
import {BreadcrumbsADPView} from './BreadcrumbsADPView';

export const BreadcrumbsADP: React.FC<
  React.PropsWithChildren<{scrollable?: boolean; className?: string}>
> = props => {
  return (
    <DataFetcher
      request={useLinksSection()}
      Error={null}
      Loading={() => <BreadcrumbsADPLoading className={props.className} />}
      View={BreadcrumbsADPView}
      viewProps={props}
    />
  );
};
